import React from "react";
import "./WorkExperienceApp.css";
import ocLogo from "./assets/ocvector.png";
import ucrLogo from "./assets/ucrgrey.png";

const WorkExperienceApp = () => {
  const experiences = [
    {
      company: "Orange County Control District",
      position: "Full Stack Development Intern",
      duration: "Jun 2025 - Sep 2025",
      description: [
        "Built GIS mapping application using Google Maps API with MarkerClusterer across 1000+ locations, supporting real-time filtering and GeoJSON/KML data processing with satellite imagery integration.",
        "Designed real-time event analytics dashboard with React and Tailwind CSS, processing 120+ employee schedules with dynamic filtering, department-specific views, and automated reporting.",
        "Developed volunteer shift portal with PHP and jQuery, featuring real-time availability, conflict detection, and PHPMailer confirmations, replacing spreadsheets and eliminating hours of scheduling across 5 departments.",
      ],
      technologies: [
        "Google Maps API",
        "React",
        "Tailwind CSS",
        "PHP",
        "jQuery",
        "PHPMailer",
        "GeoJSON",
        "KML",
      ],
      logo: ocLogo,
    },
    {
      company: "Orange County Control District",
      position: "Full Stack Development Intern",
      duration: "Jun 2024 - Sep 2024",
      description: [
        "Developed a full-stack evaluation workflow with PHP, Apache, and Microsoft SQL Server featuring competency assessments, real-time status tracking, automated email reminders, and approval routing, supporting 120+ employees.",
        "Integrated Microsoft OAuth 2.0 and Office 365 SSO authentication with secure session management, implementing JWT validation, redirect flows, and RBAC for enterprise security compliance.",
        "Designed RESTful API architecture with CORS policies, standardized error responses, and request validation, serving as unified backend across 3 platforms and 8+ internal applications.",
      ],
      technologies: [
        "PHP",
        "Apache",
        "Microsoft SQL Server",
        "OAuth 2.0",
        "Office 365 SSO",
        "JWT",
        "RBAC",
        "RESTful API",
      ],
      logo: ocLogo,
    },
    {
      company: "UCR Computer Science and Engineering Department",
      position: "Software Development Intern",
      duration: "Jun 2023 - Jun 2024",
      description: [
        "Containerized development environments with Docker across 85+ courses, creating standardized Dockerfiles and multi-container orchestration for reproducible environments serving 3800+ Computer Science students.",
        "Architected CI/CD assessment pipeline integrating PrairieLearn API with GitHub, automating version-controlled question deployment across 15+ repositories and enabling collaborative test bank development across faculty.",
        "Revamped auto-grading with Python, resulting in an average 12% increase in students' partial credit, enhancing overall assessment accuracy and feedback loop.",
      ],
      technologies: [
        "Docker",
        "GitHub",
        "PrairieLearn API",
        "CI/CD",
        "Python",
        "JSON",
        "HTML",
      ],
      logo: ucrLogo,
    },
    {
      company: "University of California, Riverside",
      position: "Grader for Advanced Data Structures and Algorithms",
      duration: "Mar 2024 - Present",
      description: [
        "Graded and provided feedback on over 160+ student assignments per week, ensuring accuracy, fairness, and consistency in evaluation.",
        "Attended weekly meetings with professors, teacher assistants, and colleagues to discuss assignment deadlines, grading criteria, and feedback raised by students.",
        "Communicated effectively with students to address questions, concerns, and academic inquiries promptly.",
      ],
      technologies: [
        "Data Structures",
        "Algorithms",
        "Grading",
        "Academic Support",
      ],
      logo: ucrLogo,
    },
  ];

  return (
    <div className="work-experience-app">
      <div className="app-header">
        <div className="app-info">
          <h2>Work Experience</h2>
          <p>Professional Journey & Career Highlights</p>
        </div>
      </div>

      <div className="experience-timeline">
        {experiences.map((exp, index) => (
          <div
            key={index}
            className={`experience-card card-${
              index % 2 === 0 ? "left" : "right"
            }`}
          >
            <div className="card-logo">
              <img src={exp.logo} alt={exp.company} />
            </div>
            <div className="card-content">
              <h4 className="company">{exp.company}</h4>
              <h3 className="position">{exp.position}</h3>
              <span className="duration">{exp.duration}</span>
              <ul className="description">
                {exp.description.map((bullet, bulletIndex) => (
                  <li key={bulletIndex}>{bullet}</li>
                ))}
              </ul>
              <div className="technologies">
                {exp.technologies.map((tech, techIndex) => (
                  <span key={techIndex} className="tech-tag">
                    {tech}
                  </span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WorkExperienceApp;
